import { Component, Input, OnInit } from '@angular/core';
import { PopoverController, MenuController } from '@ionic/angular';
import { ResourcesMenuComponent } from './resources-menu/resources-menu.component';
import { UsersMenuComponent } from './users-menu/users-menu.component';
import { Common } from '../../lib/common';
import { PageHeaderCommands } from './page-header.commands';
import { TeacherProvider } from 'src/app/providers/teacher/teacher.provider';
import { Teacher } from 'src/app/models/teacher';
import { Page } from 'src/app/models/page';
import { UpdateProvider } from '../../providers/update/update.provider'
import { WindowService } from 'src/app/services/window.service';
import { Router } from '@angular/router';
import { Subject, map, takeUntil } from 'rxjs';
import { TeacherStore } from 'src/app/stores/teacher.store';


@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent implements OnInit {

  private teacher: Teacher
  ngUnsubscribeTeacher = new Subject();
  
  width: number = 1024

  @Input() backName: string = ''
  @Input() popoverCssClass: string = ''
  @Input() sourcePage: string = ''
  @Input() courseUuid: string = ''
  @Input() lessonUuid: string = ''
  @Input() color: string = ''

  get isLessonPlans(): boolean {
    return this.popoverCssClass === 'lesson-plans'
  }

  get isPages(): boolean {
    return this.popoverCssClass === 'pages'
  }

  get isBlog(): boolean {
    return this.popoverCssClass === 'blog'
  }

  get isTeacherNotes(): boolean {
    return this.popoverCssClass === 'teacher-notes'
  }

  get hasColor(): boolean {
    return this.color != null && this.color.length > 0
  }

  get colorHex(): string {
    if (this.hasColor) {
      return '#' + this.color
    }
    return ''
  }

  isCurrentPage(url: string): boolean {
    const currentUrl = this.router.url.slice(7)
    return currentUrl === url
  }

  constructor(public commands: PageHeaderCommands,
              private teacherProvider: TeacherProvider,
              private popoverCtrl: PopoverController,
              private menuCtrl: MenuController,
              public updateProvider: UpdateProvider,
              private windowService: WindowService,
              private teacherStore: TeacherStore,
              private router: Router) {
                
                this.teacher = this.teacherProvider.teacher;
                this.teacherStore.state$
                    .pipe(takeUntil(this.ngUnsubscribeTeacher))
                    .subscribe(() => {
                      this.teacher = this.teacherProvider.teacher;
                    });
  }

  ngOnInit() {
    this.windowService.width$.subscribe((value: number) => this.width = value)

    if (this.sourcePage === 'bowling') {
      this.backName = 'Bowling Sheet'
    }
  }

  ngOnDestroy(){
    this.ngUnsubscribeTeacher.next(true);
    this.ngUnsubscribeTeacher.complete();
  }

  async presentResourcesMenu(event) {
    const popover = await this.popoverCtrl.create({
      component: ResourcesMenuComponent,
      cssClass: this.popoverCssClass + '-popover',
      event: event
    })
    popover.present().then(() => Common.ensurePopoverOnScreen())
  }

  async presentUserMenu(event) {
    const popover = await this.popoverCtrl.create({
      component: UsersMenuComponent,
      cssClass: this.popoverCssClass + '-popover',
      event: event
    })
    popover.present().then(() => Common.ensurePopoverOnScreen())
  }

  presentResponsivePageMenu(event) {
    const menu = Common.menu('responsive-menu')

    menu.side = 'end'
    menu.open('responsive-menu')
  }

  topLevelNav(): Page[] {
      const pages = new Array<Page>()
      this.teacher.pages.forEach( (page: Page) => {
        if (0 === page.parentId) {
          pages.push(page)
        }
      })
      return pages
  }

  public trackByUuid(index: number, page: Page) {
    return page.uuid;
  }

}
